/**
 * Injected via vue-meta innerHTML + .toString(). Helpers must live *inside*
 * this function so the serialized script is self-contained (module-scope
 * names like deferThirdPartyScript are not available in the browser document).
 */
const deferredThirdPartyScripts = function () {
  const injectThirdPartyScript = function (attrs = {}, onLoad) {
    const script = document.createElement('script')
    Object.keys(attrs).forEach((key) => {
      const value = attrs[key]
      if (value !== undefined && value !== null) {
        script.setAttribute(key, String(value))
      }
    })
    if (typeof onLoad === 'function') {
      script.onload = onLoad
    }
    document.body.appendChild(script)
  }

  const deferThirdPartyScript = function (attrs = {}, onLoad, timeout = 1500) {
    const loadScript = () => injectThirdPartyScript(attrs, onLoad)
    const onPageReady = () => {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(loadScript, { timeout })
      } else {
        window.setTimeout(loadScript, timeout)
      }
    }

    if (document.readyState === 'complete') {
      onPageReady()
    } else {
      window.addEventListener('load', onPageReady, { once: true })
    }
  }

  /* eslint-disable */
  deferThirdPartyScript({
    src: 'https://ratenkauf.easycredit.de/api/resource/webcomponents/v3/easycredit-components/easycredit-components.esm.js',
    type: 'module'
  }, undefined, 2000)

  deferThirdPartyScript({
    src: 'https://cdn.weglot.com/weglot.min.js',
    async: true
  }, () => {
    if (window.location.host !== 'www.zaun24.de') {
      // return;
    }
    if (typeof Weglot !== 'undefined') {
      Weglot.initialize({
        api_key: 'wg_2d7bcc26aca769fcfca73d24414b53a31'
      });
    }
  }, 2500)
  /* eslint-enable */
}

const metaInfo = {
  title: 'Zäune und Gartentore online kaufen bei ZAUN24',
  titleTemplate: '%s',
  htmlAttrs: {
    lang: 'de'
  },
  meta: [
    { charset: 'utf-8' },
    { vmid: 'description', name: 'description', content: 'Qualitativ hochwertige Zäune, Garten- und Einfahrtstore auf Wunsch mit E-Antrieb für Privat und Gewerbe. Kostenlose Beratung, freie Lieferung ab 350€' },
    { name: 'robots', content: 'index, follow' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1, minimal-ui' },
    { name: 'theme-color', content: '#ffffff' },
    { name: 'apple-mobile-web-app-status-bar-style', content: '#ffffff' }
  ],
  link: [
    { rel: 'icon', type: 'image/png', href: '/assets/favicon-32x32.png', sizes: '32x32' },
    { rel: 'icon', type: 'image/png', href: '/assets/favicon-16x16.png', sizes: '16x16' },
    { rel: 'apple-touch-icon', href: '/assets/apple-touch-icon.png' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_2048.png', sizes: '2048x2732' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_1668.png', sizes: '1668x2224' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_1536.png', sizes: '1536x2048' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_1125.png', sizes: '1125x2436' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_1242.png', sizes: '1242x2208' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_750.png', sizes: '750x1334' },
    { rel: 'apple-touch-startup-image', href: '/assets/apple_splash_640.png', sizes: '640x1136' },
    { rel: 'manifest', href: '/assets/manifest.json' },
    { rel: 'preconnect', href: 'https://web.cmp.usercentrics.eu', crossorigin: 'anonymous' },
    { rel: 'dns-prefetch', href: 'https://web.cmp.usercentrics.eu' },
    { rel: 'preconnect', href: 'https://app.usercentrics.eu', crossorigin: 'anonymous' },
    { rel: 'dns-prefetch', href: 'https://app.usercentrics.eu' }
  ],
  script: [
    {
      vmid: 'deferred-third-party-scripts',
      innerHTML: '(' + deferredThirdPartyScripts.toString() + '());',
      type: 'text/javascript'
    }
  ],
  __dangerouslyDisableSanitizersByTagID: {
    'deferred-third-party-scripts': ['innerHTML']
  }
}

export default metaInfo
